import { FunctionComponent, h } from 'preact';
import classNames from 'classnames';
import { useTheme } from '../../hooks/use-theme/use-theme';

interface Props {
	className?: string;
	applyTheme?: boolean;
	float?: boolean;
}

const Spinner: FunctionComponent<Props> = ({ className, applyTheme = false, float = false }) => {
	const { primaryColor } = useTheme();

	const themeStyle = {
		borderTop: `1.1em solid ${primaryColor}`,
		borderRight: `1.1em solid ${primaryColor}`,
		borderBottom: `1.1em solid ${primaryColor}`,
		borderLeft: '1.1em solid #f6f6f6'
	};

	return (
		<div
			className={classNames('spinner', { 'floating-spinner': float }, className)}
			data-testid="spinner"
			style={applyTheme ? themeStyle : {}}
		/>
	);
};

export default Spinner;
